<template>
  <div>
    <commonMenu v-show="isshow&&isNotApp"></commonMenu>
    <header>
      <ul>
        <li>
          <img class="img_back" src="../../assets/myicon/return1.png" alt @click="$router.go(-1)">
        </li>
        <p class="li2">报考</p>
        <li>
          <img
            v-show="isNotApp"
            class="img_menu"
            src="../../assets/myicon/mores.png"
            @click="clicks"
          >
        </li>
      </ul>
    </header>

    <div class="bktitle">
      <p>报考流程</p>
    </div>
    <div v-show="examDescription && examDescription.length > 0" class="bkDesc">
      <p>注：{{ examDescription }}</p>
    </div>
    <div v-if="my_index == 1" class="steps_one">
      <div class="steps_one_l" @click="my_index = 1">
        <p>提交信息</p>
      </div>
      <!-- <div v-show="is_pays" class="steps_one_c"> -->
      <div class="steps_one_c">
        <p>支付报名费</p>
      </div>
      <!-- <div class="steps_one_r" @click="my_index = 3"> -->
      <div class="steps_one_c" @click="towait">
        <p>等待审核</p>
      </div>
    </div>
    <div v-else-if="my_index == 2" class="steps_two">
      <div class="steps_one_c" @click="my_index = 1">
        <p>提交信息</p>
      </div>
      <!-- <div v-show="is_pays" class="steps_one_l">支付报名费</div> -->
      <div class="steps_one_l">支付报名费</div>
      <div class="steps_one_r" @click="my_index = 3">等待审核</div>
    </div>
    <div v-else class="steps_three" @click="my_index = 3">
      <div class="steps_one_c" @click="my_index = 1">提交信息</div>
      <!-- <div v-show="is_pays" class="steps_one_r">支付报名费</div> -->
      <div class="steps_one_r">支付报名费</div>
      <div class="steps_one_l" @click="towait">等待审核</div>
    </div>
    <div v-show="my_index == 3" class="step_three">
      <div class="my_status">
        <img v-show="status_t == 2" class="examine" src="../../static/sh1.png" alt>
        <img v-show="status_t == 4" class="examine" src="../../static/jujue_img.png" alt>
        <img v-show="status_t == 3 || status_t == 5" class="examine" src="../../static/tongguo_img.png" alt>
        <p v-show="status_t == 2" class="cs0">等待审核</p>
        <p v-show="status_t == 4" class="cs0">未通过审核</p>
        <p v-show="status_t == 3" class="cs0">审核通过</p>
        <p v-show="status_t == 5" class="cs0">报名成功</p>
        <p v-show="status_t == 2" class="cs1">正在等待审核</p>
        <p v-show="status_t == 4" class="cs1">因为{{ refuse_reason }}，您的审核未通过</p>
        <p v-show="status_t == 3" class="cs1">恭喜您，已通过审核</p>
        <p v-show="status_t == 5" class="cs1">恭喜您，正在提交发证单位</p>
        <button v-if="status_t != 3 && status_t != 5" @click="go_edits()">重新编辑信息{{ status_t }}</button>
        <button v-else @click="go_edits()">查看报考信息{{ status_t }}</button>
      </div>
    </div>
    <div v-show="my_index == 1 && itemsConfirm[0].show" class="liebiao">
      <van-form @submit="onSubmit">
        <van-field
          v-model="from.real_name"
          name="姓名"
          label="姓名"
          placeholder="姓名"
          :required="itemsConfirm[0].require"
          :rules="itemsConfirm[0].require?[{ required: true, message: '请填写姓名' }]:[]"
        />
        <van-field v-show="itemsConfirm[1].show" name="radio" label="性别" :required="itemsConfirm[1].require">
          <template #input>
            <van-radio-group v-model="from.gender" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="0">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div v-show="itemsConfirm[2].show" class="tu1">
          <van-field v-model="from.nation_id" name="民族" label="民族" :required="itemsConfirm[2].require" class="usema" />
          <van-collapse v-model="activeNames">
            <van-collapse-item ref="mz" name="1">
              <template #title>
                <div>{{ nation_name ? nation_name : "请选择" }}</div>
              </template>
              <div
                v-for="(item, index) in Nations"
                :key="index"
                class="educations"
                @click="click_Nations(index)"
              >{{ item.nation }}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <van-form v-show="itemsConfirm[3].show" @submit="onSubmit">
          <van-field v-model="from.native_place" name="籍贯" label="籍贯" placeholder="籍贯" :required="itemsConfirm[3].require" />
        </van-form>
        <!-- 证件类型 -->
        <div v-show="itemsConfirm[4].show" class="tu1">
          <van-field v-model="from.document_type" name="证件类型" label="证件类型" :required="itemsConfirm[4].require" class="usema" />
          <van-collapse v-model="activeNames5">
            <van-collapse-item ref="zj" name="1">
              <template #title>
                <div>{{ document_type_name ? document_type_name : "请选择" }}</div>
              </template>
              <div
                v-for="(item, index) in document_type_list"
                :key="index"
                class="educations"
                @click="click_document_type(index)"
              >{{ item.name }}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <van-form v-show="itemsConfirm[5].show" @submit="onSubmit">
          <van-field v-model="from.id_number" name="证件号码" label="证件号码" placeholder="证件号码" :required="itemsConfirm[5].require" :rules="[{ required: true, message: '请填写证件号码' },{validator, message: '证件号码格式错误！'}]" />
        </van-form>
        <div v-show="itemsConfirm[6].show" class="tu1">
          <van-field v-model="from.education" name="文化程度" label="文化程度" :required="itemsConfirm[6].require" class="usema" />
          <van-collapse v-model="activeNames1">
            <van-collapse-item ref="wh" name="1">
              <template #title>
                <div>{{ education_name ? education_name : "请选择" }}</div>
              </template>
              <div
                v-for="(item, index) in whcd_list"
                :key="index"
                class="educations"
                @click="click_edu(index)"
              >{{ item.education }}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <div v-show="itemsConfirm[7].show" class="tu1">
          <van-field v-model="username" name="考试地区" label="考试地区" :required="itemsConfirm[7].require" class="usema" />
          <van-collapse v-model="activeNames3">
            <van-collapse-item ref="shengS" name="1">
              <template #title>
                <div>
                  {{
                    `${sheng_name ? sheng_name : "省"}&nbsp;/&nbsp;${
                      shi_name ? shi_name : "市"
                    }`
                  }}
                </div>
              </template>

              <div class="sele">
                <span>选择省</span>
                <select v-model="sheng_name" @change="sele_change_sheng()">
                  <option value>请选择</option>
                  <option
                    v-for="(item, index) in address_list_sheng"
                    :key="index"
                    @click="get_sheng_id(item.id)"
                  >{{ item.cname }}</option>
                </select>
              </div>
              <div class="sele">
                <span>选择市</span>
                <select v-model="shi_name" @change="sele_change_shi()">
                  <option value>请选择</option>
                  <option v-for="(item, index) in address_list_shi" :key="index">{{ item.cname }}</option>
                </select>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <!-- 考场 -->
        <div v-show="itemsConfirm[8].show" class="tu1">
          <van-field v-model="from.exam_center" name="考场" label="考场" :required="itemsConfirm[8].require" class="usema" />
          <van-collapse v-model="activeNames4">
            <van-collapse-item ref="kc" name="1">
              <template #title>
                <div>{{ exam_center_name ? exam_center_name : "请选择" }}</div>
              </template>
              <div
                v-for="(item, index) in kc_list"
                :key="index"
                class="educations"
                @click="click_exam_center(index)"
              >{{ item.name }}</div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <van-form v-show="itemsConfirm[11].show" @submit="onSubmit">
          <van-field
            v-model="from.wechat_number"
            name="微信号"
            label="微信号"
            placeholder="微信号"
            :required="itemsConfirm[11].require"
          />
        </van-form>
        <van-form v-show="itemsConfirm[12].show" @submit="onSubmit">
          <van-field v-model="from.address" name="邮寄地址" label="邮寄地址" placeholder="邮寄地址" :required="itemsConfirm[12].require" />
        </van-form>
        <van-form v-show="itemsConfirm[13].show" @submit="onSubmit">
          <van-field v-model="from.company" name="工作单位" label="工作单位" placeholder="工作单位" :required="itemsConfirm[13].require" />
        </van-form>
        <van-form v-show="itemsConfirm[14].show" @submit="onSubmit">
          <van-field v-model="from.postal_code" name="邮编" label="邮编" placeholder="邮编" :required="itemsConfirm[14].require" />
        </van-form>
        <van-form v-show="itemsConfirm[9].show" @submit="onSubmit">
          <van-field v-model="from.phone_number" name="手机号" label="手机号" maxlength="11" type="number" placeholder="手机号" :required="itemsConfirm[9].require">
            <template #button>
              <van-button v-show="status_t!=5 && status_t!=3" size="small" type="primary" @click="send_reg()">发送验证码</van-button>
            </template>
          </van-field>
        </van-form>
        <van-field
          v-show="itemsConfirm[9].show&&(status_t!=5 && status_t!=3)"
          v-model="from.code"
          center
          clearable
          :required="itemsConfirm[9].require"
          label="短信验证码"
          placeholder="请输入短信验证码"
        ></van-field>

        <div v-show="itemsConfirm[15].show" class="tu" :required="itemsConfirm[15].require">
          <van-field name="图片上传" label="上传照片" :required="itemsConfirm[15].require" />
          <!--
          <van-uploader v-model="fileList"  style="margin-left: 28px" :after-read="afterRead" />
-->

          <van-uploader v-model="fileList" style="margin-left: 28px" :after-read="afterRead" :before-read="isOverSize" />
          <!-- <div v-if="remark.img_width" class="uploadBox" @click="toggleShow"></div> -->
        </div>
        
      </van-form>
    </div>
    <div v-show="my_index == 1&&itemsConfirm[15].show" class="cia">
      <div v-html="remark.img_desc"></div>
      <!-- <p>只支持 .jpg 格式</p>
      <p>1.必须是jpg文件，正规照相馆拍摄</p>
      <p>2.白底免冠大头像，否则会影响证书效果</p>
      <p>3.照片尺寸为250x350像素</p>
      <p>4.照片名称以本人的证件号码命名</p>
      <p>例：110010199001020001.jpg</p> -->
    </div>
    <div v-show="(status_t!=5 && status_t!=3) && my_index == 1" class="btnDiv">
      <button class="btnStyle" @click="commits()">提交</button>
    </div>

    <!-- 剪切图片的弹框-->
    <el-dialog
       width="360px"
      :close-on-click-modal="false"
      :visible.sync="isCropper"
      title="图片裁剪"
      class="upload_dialog_a"
    >
      <div class="vue-cropper-box">
        <div class="vue-cropper-content" style="height:400px;width:100%;">
          <div>
            <div :span="16">
              <vueCropper
                ref="cropper"
                style="height:400px;"
                :mode="option.mode"
                :img="option.img"
                :output-size="option.size"
                :output-type="option.outputType"
                :info="option.info"
                :full="option.full"
                :can-move="option.canMove"
                :can-move-box="option.canMoveBox"
                :center-box="option.centerBox"
                :original="option.original"
                :auto-crop="option.autoCrop"
                :auto-crop-width="option.autoCropWidth"
                :auto-crop-height="option.autoCropHeight"
                :fixed-box="option.fixedBox"
                :fixed="option.fixed"
                :fixed-number="option.fixedNumber"
              ></vueCropper>
            </div>
          </div>
        </div>
      </div>
      <div class="operate-wrap">
        <div class="up_foot_box clearfix">
          <!-- <van-uploader
          v-mode="upFileList"
          :before-read="beforeUpload"
          :after-read="handleChange"
        >
          <van-button size="small" class="up_foot_button" type="primary" plain >
            选择需裁剪图片
          </van-button>
        </van-uploader> -->
          <!-- <a-button
            class="up_foot_button"
            type="primary"
            style="position:relative;display:inline-block;width: 70px;padding: 0;text-align: center;line-height: 28px;"
          >
            选择图片
            <input
              id="uploads"
              type="file"
              style="position:absolute;z-index:1001;left:0;top:0; width:70px;opacity:0;"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="beforeAvatarUploadPS"
            >
          </a-button> -->
          <van-button class="up_foot_button" size="small" type="primary" plain @click="changeScale(1)">放大</van-button>
          <van-button class="up_foot_button" size="small" type="primary" plain @click="changeScale(-1)">缩小</van-button>
          <van-button class="up_foot_button" size="small" type="primary" plain @click="uploadImg">确定</van-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from '@/utils/tools.js'
import commonMenu from '@/components/common/menu'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { Popup } from 'vant';
import {
  commits_bm,
  getInfo,
  getwhcd,
  get_sheng,
  get_Nation,
  get_reg,
  getFormSetting,
  getCenter,
  getDuctmenttype,
  getExamImgIs
} from '@/api/examination.js'
import { VueCropper } from 'vue-cropper'
import myUpload from 'vue-image-crop-upload'
import Cookies from 'js-cookie'
import axios from 'axios'
// import Curse from '../home/Curse'
export default {
  components: { commonMenu, VueCropper, myUpload },

  data() {
    return {
      isshow: false,
      isNotApp: true,
      is_pays: true,
      // fileList: [{ url: '' }],
      fileList: [],
      nation_name: '',
      sheng_name: '',
      shi_name: '',
      address_list_sheng: [],
      address_list_shi: [],
      my_index1: 1,
      my_index: this.$route.query.my_index || 1,
      username: '',
      password: '',
      radio: '1',
      sms: '',
      // activeNames: '',
      value: '',
      activeNames: ['0'],
      activeNames1: ['0'],
      activeNames2: ['0'],
      activeNames3: ['0'],
      activeNames4: ['0'],
      activeNames5: ['0'],
      whcd_list: [],
      kc_list: [],
      education_name: '',
      exam_center_name: '',
      Nations: [],
      status_t: 0, // 状态 0未报名 1未支付报名费 2待审核 3通过 4拒绝 5报名成功
      refuse_reason: '', // 拒绝理由
      constm: '', // 报名费
      imgWidth: '',
      imgHeight: '',
      imgShow: false,
      ispay: '',
      from: {
        id: '',
        exam_center_id: '',
        status: '',
        real_name: '',
        gender: '',
        nation_id: '',
        native_place: '',
        id_number: '',
        education: '',
        exam_id: '',
        province_id: '',
        city_id: '',
        phone_number: '',
        wechat_number: '',
        address: '',
        company: '',
        postal_code: '',
        picture: '',
        code: '',
        upArr: [],
        document_type: ''

      },
      itemsConfirm: [
        {
          id: 1,
          title: '姓名',
          show: false,
          require: false
        },
        {
          id: 2,
          title: '性别',
          show: false,
          require: false
        },
        {
          id: 3,
          title: '民族',
          show: false,
          require: false
        },
        {
          id: 4,
          title: '籍贯',
          show: false,
          require: false
        },
        {
          id: 15,
          title: '证件类型',
          show: false,
          require: false
        },
        {
          id: 5,
          title: '证件号码',
          show: false,
          require: false
        },
        {
          id: 6,
          title: '文化程度',
          show: false,
          require: false
        },
        {
          id: 7,
          title: '考试地区',
          show: false,
          require: false
        },
        {
          id: 8,
          title: '考试',
          show: false,
          require: false
        },
        {
          id: 9,
          title: '手机号',
          show: false,
          require: false
        },
        {
          id: 16,
          title: '手机验证码',
          show: false,
          require: false
        },
        {
          id: 10,
          title: '微信号',
          show: false,
          require: false
        },
        {
          id: 11,
          title: '邮寄地址',
          show: false,
          require: false
        },
        {
          id: 12,
          title: '工作单位',
          show: false,
          require: false
        },
        {
          id: 13,
          title: '邮编',
          show: false,
          require: false
        },
        {
          id: 14,
          title: '上传照片',
          show: false,
          require: false
        }
      ],
      // 说明
      examDescription: '',
      document_type_name: '',
      document_type_list: [],// 证件类型
      // 上传组件
      isCropper: false,
      // 裁剪组件的基础配置option
      previews: {},
      zlb_name: '',
      option: {
        mode:'auto',
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 1, // 剪切后的图片质量（0.1-1）
        full: true, // 输出原图比例截图 props名full
        canScale:true,//	图片是否允许滚轮缩放
        outputType: 'jpg', // 裁剪生成额图片的格式
        canMove: true, // 能否拖动图片
        original: false, // 上传图片是否显示原始宽高
        canMoveBox: true, // 能否拖动截图框
        centerBox: true, // 截图框是否限制在图片里面
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 180, // 默认生成截图框宽度
        autoCropHeight: 180, // 默认生成截图框高度
        fixedBox: true, // 截图框固定大小
        fixed: true,
        // fixedNumber: [1, 1] // 截图框的宽高比例
      },
      fileList:[],
      upfileName:'',
      show_box: false, // 剪切框显示和隐藏的flag
      size: 2.1,
      langExt:{
          hint: '点击上传图片',
          loading: '正在上传……',
          noSupported: '浏览器不支持该功能，请使用IE10以上或其他现在浏览器！',
          success: '上传成功',
          fail: '图片上传失败',
          preview: '图像预览',
          btn: {
              off: '取消',
              close: '关闭',
              back: '上一步',
              save: '保存'
          },
          error: {
              onlyImg: '仅限图片格式',
              outOfSize: '单文件大小不能超过 ',
              lowestPx: '图片最低像素为（宽*高）：'
          }
      },
      // 上传图片要求
      remark:{
        img_width: '',
        img_height: '',
        min_size: '',
        max_size: '',
        img_required: false,
        img_checked: 0,
        img_desc: ''
      },
      upFileList:[]
    }
  },
  created() {
    this.isToLogin()
  },
  mounted() {
    if (tool.isInApp()) {
      this.isNotApp = false
    } else {
      this.isNotApp = true
    }
    this.getData()
    this.get_info() // 回显信息
    this.is_pay()
    this.getCardType()
  },
  methods: {
    // 上传
    uploadImg(){
      this.$refs.cropper.getCropData(data => {
        // console.log(data);
        let formData = new FormData();
        formData.append("file", this.dataURLtoFile(data,this.upfileName));
        axios({
          url: 'https://f.zhulong.com/uploadZhulongImgForEdit.php',
          method: 'post',
          data:formData
        }).then((res)=>{
          this.cropUploadSuccess(res.data.url)
        })
      })
    },
    dataURLtoFile(dataurl,filename) {
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        //转换成file对象
        return new File([u8arr], filename, {type:mime});
        //转换成成blob对象
        //return new Blob([u8arr],{type:mime});
    },
    beforeUpload(file) {
      console.log(file,'pppppp');
      if(this.remark.img_required){
        var imgname = ''
        imgname = file.name.slice(0, -4) != this.from.id_number
        if (imgname) {
          Toast('照片名称请以考生本人的证件号码命名 !')
          this.isCropper = false
          return false
        }
      }
      const fd = new FormData()
          fd.append('files', file)
      axios
      .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', fd)
      .then((res) => {
        console.log(res)
        console.log(res.data.url);
        this.option.img = res.data.url
      })
    },
    handleChange(e){
      console.log(e);
      // this.option.img = e.file?.response?.url
    },
    // 缩放
    changeScale(e) {
      this.$refs.cropper.changeScale(e)
    },
    // 上传图片组件
    toggleShow() {
      console.log(11111);
      this.isCropper =!this.isCropper
      // this.show_box = !this.show_box
    },
    // 用户选取图片之后
    srcFileSet(filename){
      if(this.remark.img_required){
        var imgname = ''
        imgname = filename.slice(0, -4) != this.from.id_number
        if (imgname) {
          Toast('照片名称请以考生本人的证件号码命名 !')
          this.show_box = false
        }
      }
    },
    // 上传成功
    cropUploadSuccess(res, file) {
      var info={
        exam_id: this.$route.query.id,
        img: res
      }
      getExamImgIs(info).then((res)=>{
        if(res.errNo==0){
          this.from.picture = res.result
          this.fileList = [{url:res.result,name:this.upFileName}]
          this.isCropper = false
        }else{
          this.from.picture = ''
          this.fileList = []
          this.isCropper = false
          Toast(res.msg)
          Dialog.alert({
            title: '提示',
            message: '裁剪后图片大小不满足' + this.remark.min_size + 'kb到' + this.remark.max_size + 'kb之间',
          })
        }
      })
    },
    beforeAvatarUploadPS(e) {
      var file = e.target.files[0]
      this.option.img = URL.createObjectURL(file)
      const isDWG = file.name.split('.')
      const format = isDWG[isDWG.length - 1]
      // this.uploadParams.isFile = "1";
      // uploadParams.file="";
      // if (format != 'jpg') {
      //   this.$message.error('上传文件只能是jpg格式!')
      //   return false
      // }
      this.isCropper = true
    },
    click_document_type(index) {
      this.from.document_type = this.document_type_list[index].id
      this.document_type_name = this.document_type_list[index].name
      this.$refs.zj.toggle(false)
    },
    getCardType() {
      getDuctmenttype().then((res) => {
        this.document_type_list = res.result
      })
    },
    // 身份证校验
    validator(val) {
      if (this.from.document_type == 1) {
        const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        return card18.test(val)
      } else {
        if (val) {
          return true
        } else {
          return false
        }
      }
    },
    getData() {
      var info = {
        exam_id: this.$route.query.id
      }
      getFormSetting(info).then((res) => {
        if (res.errNo == 0) {
          const result = res.result
          if (res.result.length) {
            for(let i=0;i<result.length;i++){
              if(result[i].type==14){
                this.remark = result[i].remark||''
                if(this.remark.img_width){
                  this.option.autoCropWidth = this.remark.img_width
                  this.option.autoCropHeight = this.remark.img_height
                  this.option.fixedNumber = [this.remark.img_width,this.remark.img_height]
                  console.log(this.option,'this.option');
                }else{
                  this.option.mode = 'contain'
                  this.option.fixedBox = false
                  this.option.fixed = false
                } 
              }
            }
            this.itemsConfirm.forEach(item => {
              res.result.forEach(obj => {
                if (item.id === obj.type) {
                  item.show = Boolean(obj.is_show)
                  item.require = Boolean(obj.is_required)
                }
              })
            })
            
          }
          // console.log(this.itemsConfirm, '99999')
        }
        // console.log(res.result, '<<<<<<<<')
      })
    },
    clicks() {
      console.log(this.isNotApp + '----------' + this.isshow)

      if (this.isshow === false) {
        this.isshow = true
      } else {
        this.isshow = false
      }

      console.log(this.isNotApp + '----------' + this.isshow)
    },
    // 这块要改
    is_pay() {
      if (this.$route.query.money === 0) {
        // if(true){
        this.is_pays = false
      } else {
        this.is_pays = true
      }
    },
    // 这块要改
    towait() {
      if (this.status_t == 0 || this.status_t == 1) {
        Toast('请填写报考信息并支付')
      } else {
        this.my_index = 3
      }
      // else if (this.status_t == 0 && this.ispay == 0 && this.constm > 0) {
      //   Toast('请填写报考信息并支付')
      // }
    },
    afterRead(e) {
      // var picture_m = this.from.picture
      // console.log(picture_m, 'picture_m')
      var arr = e.content.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      var f = new Blob([u8arr], { type: mime })

      var reader = new FileReader()
      reader.onload = function(e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.src = data
      }
      reader.readAsDataURL(f)
      console.log(Cookies.get('aa'), 'ssss')
      setTimeout(() => {
        if (Cookies.get('aa')) {
          this.from.picture = ''
          this.fileList = []
        } else {
          console.log(e, 'e')
          this.fd = new FormData()
          console.log(e.file)
          this.fd.append('files', e.file)
          // this.$set(this.fd,[],e.file)

          // this.upArr = this.fd.getAll("files[]");
          console.log(this.fd)
          axios
            .post('https://f.zhulong.com/uploadZhulongImgForEdit.php', this.fd)
            .then((info) => {
              const res = info.data
              // 判断上传图片是否符合设置
              if(res.filesize<this.remark.min_size*1024){
                Dialog.alert({
                    title: '提示',
                    message: '上传失败，请上传' + this.remark.min_size + 'kb到' + this.remark.max_size + 'kb之间的图片',
                  })
                  this.from.picture = ''
                  this.fileList = []
                return false
              }else if(Number(res.width)<Number(this.remark.img_width)||Number(res.height)<Number(this.remark.img_height)){
                Dialog.alert({
                    title: '提示',
                    message: '上传图片尺寸过小',
                  })
                  this.from.picture = ''
                  this.fileList = []
                return false
              } else if(res.width==this.remark.img_width&&res.height==this.remark.img_height&&res.filesize>=this.remark.min_size*1024&&res.filesize<=this.remark.max_size*1024){
                this.from.picture = res.url
              }else{
                this.from.picture = ''
                this.fileList = []
                this.option.img = res.url
                this.isCropper = true
              }
              // var info={
              //   exam_id:this.$route.query.id,
              //   img:res.data.url
              // }
              // getExamImgIs(info).then((res)=>{
              //   if(res.errNo==0){
              //     this.from.picture = res.result  
              //   }else{
              //     this.from.picture = ''
              //     this.fileList = []
              //     Toast(res.msg)
              //   }
              // })
              // this.from.picture = res.data.url
            })
        }
      }, 200)
    },
    send_reg() {
      var params = {
        phone: this.from.phone_number
      }
      get_reg(params).then((res) => {
        Toast(res.result)
      })
    },
    // 民族列表
    get_Nations() {
      get_Nation().then((res) => {
        // console.log(res.result)
        this.Nations = res.result
        this.Nations.forEach(res => {
          if (this.from.nation_id == res.id) {
            this.nation_name = res.nation
          }
        })
      })
    },
    // 获得市ID
    sele_change_shi() {
      this.kc_list = []
      this.activeNames4 = ['0']
      this.exam_center_name = ''
      this.from.exam_center_id = ''
      const obj1 = this.address_list_shi.find((item) => {
        if (this.shi_name === item.cname) {
          return item
        }
      })
      this.from.city_id = obj1.id
      // console.log(this.shengId, this.from.city_id, 'sssssss')
      this.getKc()
      this.$refs.shengS.toggle(false)
    },
    // 获取考场
    getKc() {
      var info = {
        exam_id: this.$route.query.id,
        province_id: this.shengId,
        city_id: this.from.city_id
      }
      getCenter(info).then((res) => {
        // console.log(res, '考场')
        if (res.errNo == 0) {
          this.kc_list = res.result
        }
      })
    },
    // 获取省
    getsheng() {
      get_sheng({ exam_id: this.$route.query.id }).then((res) => {
        this.address_list_sheng = res.result
        console.log(res)
      })
    },
    // 省ID
    sele_change_sheng() {
      this.kc_list = []
      this.activeNames4 = ['0']
      this.exam_center_name = ''
      this.from.exam_center_id = ''
      const obj = this.address_list_sheng.find((item) => {
        if (this.sheng_name === item.cname) {
          return item
        }
      })
      this.shi_name = ''
      this.shengId = obj.id
      this.from.province_id = obj.id
      console.log(this.shengId)
      this.getshi()
    },
    // 获取省id对应的市列表
    getshi() {
      var params = {
        exam_id: this.$route.query.id,
        parent_id: this.shengId
      }
      get_sheng(params).then((res) => {
        this.address_list_shi = res.result
        console.log(res)
      }).then((res) => {
        this.getKc()
      })
    },
    click_Nations(index) {
      // console.log(index)
      this.from.nation_id = this.Nations[index].id
      this.nation_name = this.Nations[index].nation
      console.log(this.from.nation_id)
      this.$refs.mz.toggle(false)
    },
    click_edu(index) {
      this.from.education = this.whcd_list[index].id
      this.education_name = this.whcd_list[index].education
      console.log(this.from.education)
      this.$refs.wh.toggle(false)
    },
    // 选择考场
    click_exam_center(index) {
      console.log(index)
      this.exam_center_name = this.kc_list[index].name
      this.from.exam_center_id = this.kc_list[index].id
      this.$refs.kc.toggle(false)
    },
    get_whcd() {
      getwhcd().then((res) => {
        this.whcd_list = res.result
        this.whcd_list.forEach(res => {
          if (this.from.education == res.id) {
            this.education_name = res.education
          }
        })
      })
    },
    get_info() {
      var params = {
        exam_id: this.$route.query.id
        // id: this.$route.query.id
      }
      getInfo(params).then((res) => {
        console.log(res, 'res')
        if (res.result != null) {
          // this.fileList = [{ url: '' }]
          this.from.id = res.result.id ? res.result.id : ''
          this.from.status = res.result.status
          this.from.address = res.result.address
          this.from.city_id = res.result.city_id
          this.from.company = res.result.company
          this.from.education = res.result.education
          this.from.exam_center_id = res.result.exam_center_id
          this.exam_center_name = res.result.exam_center_name
          this.from.exam_id = res.result.exam_id
          this.from.gender = res.result.gender
          this.from.id_number = res.result.id_number
          this.from.nation_id = res.result.nation_id
          this.from.native_place = res.result.native_place
          this.from.phone_number = res.result.phone_number
          this.from.picture = res.result.picture
          // this.fileList[0].url = res.result.picture
          this.from.postal_code = res.result.postal_code
          this.from.province_id = res.result.province_id
          this.sheng_name = res.result.province
          this.shi_name = res.result.city
          this.from.real_name = res.result.real_name
          this.from.wechat_number = res.result.wechat_number
          this.status_t = res.result.status
          this.refuse_reason = res.result.refuse_reason
          this.constm = res.result.exam_money
          this.ispay = res.result.is_pay
          // 考试说明
          this.examDescription = res.result.description
          this.from.document_type = res.result.document_type
          this.document_type_name = res.result.document_name

          if (res.result.picture) {
            this.fileList = [{ url: '' }]
            this.fileList[0].url = res.result.picture
          }
          // 未支付 去付款
          const statu = res.result.status
          // statu = 1 未支付
          if (statu === 1) {
            Dialog.confirm({
              title: '提示',
              message: '考生您好，您还未支付报名费～',
              confirmButtonText: '去支付'
            })
              .then(() => {
                this.toPayMoney()
              })
              .catch(() => {
              // on cancel
              })
          }
        }
      }).then(message => {
        this.get_Nations()
        this.getsheng()
        this.get_whcd() // 文化程度
        this.shengId = this.from.province_id
        this.getshi()
      })
    },
    commits() {
      setTimeout(() => {
        const params = {
          id: this.from.id,
          status: this.from.status,
          exam_id: this.$route.query.id
        }
        // 姓名
        if (this.itemsConfirm[0].show) {
          const name = this.from.real_name
          if (this.itemsConfirm[0].require) {
            if (name && name.length > 0) {
              params.real_name = name
            } else {
              return Toast('请输入姓名')
            }
          } else {
            params.real_name = name
          }
        }
        // 性别
        if (this.itemsConfirm[1].show) {
          const gender = Number(this.from.gender)
          if (this.itemsConfirm[1].require) {
            if (gender >= 0) {
              params.gender = gender
            } else {
              return Toast('请选择性别')
            }
          } else {
            params.gender = gender
          }
        }
        // 民族
        if (this.itemsConfirm[2].show) {
          const nation = Number(this.from.nation_id)
          if (this.itemsConfirm[2].require) {
            if (nation > 0) {
              params.nation_id = nation
            } else {
              return Toast('请选择民族')
            }
          } else {
            params.nation_id = nation
          }
        }
        // 籍贯
        if (this.itemsConfirm[3].show) {
          const nativePlace = this.from.native_place
          console.log('nativePlace ' + nativePlace)
          if (this.itemsConfirm[3].require) {
            if (nativePlace) {
              params.native_place = nativePlace
            } else {
              return Toast('请输入籍贯')
            }
          } else {
            params.native_place = nativePlace
          }
        }
        // 证件类型
        if (this.itemsConfirm[4].show) {
          const document_type = Number(this.from.document_type)
          if (this.itemsConfirm[4].require) {
            if (document_type > 0) {
              params.document_type = document_type
            } else {
              return Toast('请选择证件类型')
            }
          } else {
            params.document_type = document_type
          }
        }
        // 身份证
        if (this.itemsConfirm[5].show) {
          const cardId = this.from.id_number
          console.log('cardId ' + cardId)
          if (this.from.document_type == 1) {
            if (this.itemsConfirm[5].require) {
              if (cardId) {
                params.id_number = cardId
              } else {
                return Toast('请输入证件号码')
              }
            } else {
              params.id_number = cardId
            }
          } else {
            if (this.itemsConfirm[5].require) {
              if (cardId) {
                params.id_number = cardId
              } else {
                return Toast('请输入证件号码')
              }
            } else {
              params.id_number = cardId
            }
          }
        }
        // 文化成都
        if (this.itemsConfirm[6].show) {
          const education = this.from.education
          console.log('education ' + education)
          if (this.itemsConfirm[6].require) {
            if (education) {
              params.education = education
            } else {
              return Toast('请选择文化程度')
            }
          } else {
            params.education = education
          }
        }
        // 考试地区
        if (this.itemsConfirm[7].show) {
          var province_id = this.from.province_id
          var city_id = this.from.city_id
          console.log('province_id ' + province_id)
          console.log('city_id ' + city_id)
          if (this.itemsConfirm[7].require) {
            if (province_id && city_id) {
              params.province_id = province_id
              params.city_id = city_id
            } else {
              return Toast('请选择考试地区')
            }
          } else {
            params.province_id = province_id
            params.city_id = city_id
          }
        }
        // 手机号
        if (this.itemsConfirm[9].show) {
          const phone = this.from.phone_number
          console.log('phone ' + phone)
          if (this.itemsConfirm[9].require) {
            if (phone) {
              params.phone_number = phone
            } else {
              return Toast('请输入手机号')
            }
          } else {
            params.phone_number = phone
          }
        }
        // 验证码
        if (this.itemsConfirm[9].show) {
          const yzm = this.from.code
          console.log('yzm ' + yzm)
          if (this.itemsConfirm[9].require) {
            if (yzm) {
              params.code = yzm
            } else {
              return Toast('请输入手机验证码')
            }
          } else {
            params.code = yzm
          }
        }
        // 微信
        if (this.itemsConfirm[11].show) {
          const wx = this.from.wechat_number
          console.log('wx ' + wx)
          if (this.itemsConfirm[11].require) {
            if (wx) {
              params.wechat_number = wx
            } else {
              return Toast('请输入微信号')
            }
          } else {
            params.wechat_number = wx
          }
        }
        // 地址
        if (this.itemsConfirm[12].show) {
          const addInfo = this.from.address
          console.log('addInfo ' + addInfo)
          if (this.itemsConfirm[12].require) {
            if (addInfo) {
              params.address = addInfo
            } else {
              return Toast('请输入邮寄地址')
            }
          } else {
            params.address = addInfo
          }
        }
        // 单位
        if (this.itemsConfirm[13].show) {
          const position = this.from.company
          console.log('position ' + position)
          if (this.itemsConfirm[13].require) {
            if (position) {
              params.company = position
            } else {
              return Toast('请输入工作单位')
            }
          } else {
            params.company = position
          }
        }
        // 邮编
        if (this.itemsConfirm[14].show) {
          const email = this.from.postal_code
          console.log('email ' + email)
          if (this.itemsConfirm[14].require) {
            if (email) {
              params.postal_code = email
            } else {
              return Toast('请输入邮编')
            }
          } else {
            params.postal_code = email
          }
        }
        // 照片
        if (this.itemsConfirm[15].show) {
          const picture = this.from.picture
          console.log('picture ' + picture)
          if (this.itemsConfirm[15].require) {
            if (picture) {
              params.picture = picture
            } else {
              return Toast('请上传照片')
            }
          } else {
            params.picture = picture
          }
        }
        // 考场
        if (this.itemsConfirm[8].show) {
          const kaochang = this.from.exam_center_id
          if (this.itemsConfirm[8].require) {
            if (kaochang) {
              params.exam_center_id = kaochang
            } else {
              return Toast('请选择考场')
            }
          } else {
            params.exam_center_id = kaochang
          }
        }
        // var params = {
        //   id: this.$route.query.id,
        //   exam_center_id: this.from.exam_center_id,
        //   status: this.from.status,
        //   real_name: this.from.real_name,
        //   gender: this.from.gender,
        //   nation_id: this.from.nation_id,
        //   native_place: this.from.native_place,
        //   id_number: this.from.id_number,
        //   education: this.from.education,
        //   exam_id: this.$route.query.id,
        //   province_id: this.from.province_id,
        //   city_id: this.from.city_id,
        //   phone_number: this.from.phone_number,
        //   wechat_number: this.from.wechat_number,
        //   address: this.from.address,
        //   company: this.from.company,
        //   postal_code: this.from.postal_code,
        //   picture: this.from.picture,
        //   code: this.from.code
        // }
        console.log(params, 'params')
        commits_bm(params).then(res => {
          console.log(res)
          if (res.errNo === 0) {
            this.my_index = 2
            window.location.href = window.location.origin`/shop/pay?product_type=6&product_id=${this.$route.query.id}&fromurl=${window.location.href}`
          } else {
            Toast(res.msg)
          }
        })
        // console.log(params)
      }, 1500)
    },
    go_edits() {
      this.my_index = 1
    },
    isOverSize(file) {
      console.log(file);
      if(this.remark.img_required){
        const imgtitle = file.name.slice(0, -4) == this.from.id_number
        if (!imgtitle) {
          this.$message.error('照片名称请以考生本人的证件号码命名!')
          return false
        }
      }
      this.upfileName = file.name
      return true
      // const isSize = new Promise(function(resolve, reject) {
      //   const width = this.remarlk.img_width
      //   const height = this.remark.img_height
      //   const _URL = window.URL || window.webkitURL
      //   const img = new Image()
      //   img.onload = function() {
      //     const valid = img.width <= width && img.height <= height
      //     valid ? resolve() : reject()
      //   }
      //   img.src = _URL.createObjectURL(file)
      // }).then(() => {
      //   return file
      // }, () => {
      //   // this.$message.error('上传的照片尺寸必须为250*350!')
      //   return Promise.reject()
      // })
      // // 图片大小在限制范围内
      // if(file.size>=this.remark.min_size*1024&&file.size<=this.remark.max_size*1024){
      //   console.log(1111);
      //   return isSize&&true
      // }else{
      //   console.log(2222);
      //   this.isCropper = true
      //   this.option.img = ''
      //   return false
      // }
    },
    onSubmit(values) {
      console.log('submit', values)
    },
    // afterRead(file) {
    //   // 此时可以自行将文件上传至服务器
    //   console.log(file);

    // },
    // 判断登录
    isToLogin() {
      var url = encodeURIComponent(location.href)
      if (!Cookies.get('uid') || !Cookies.get('username')) {
        if (process.env.NODE_ENV === 'development') {
          window.open(`/login?redirect=${url}`, '_self')
        } else {
          window.open(`/login?redirect=${url}`, '_self')
        }
        return false
      } else {
        return true
      }
    },
    // 去支付报名费
    toPayMoney() {
      window.location.href = window.location.origin`/shop/pay?product_type=6&product_id=${this.$route.query.id}&fromurl=${window.location.href}`
    }
  }
}
</script>

<style lang="scss" scoped>
select {
  border: none;
  // color: #ccc;
  background: #fff;
  padding-left: 15px;
  margin: 10px;
}
.educations {
  padding: 10px;
  border-bottom: 1px solid #f1f0f0;
  width: 100%;
  // transform: scale(0.5);
}
.my_status {
  text-align: center;
  overflow: hidden;
}
.cs0 {
  margin-top: 33px;
  font-size: 40px;
}
.cs1 {
  padding-top: 27px;
  color: #9b9b9b;
}
.my_status button {
  width: 438px;
  height: 87px;
  border: 1px solid #ee2e2e;
  color: #ee2e2e;
  background: #fff;
  margin-top: 80px;
}
.examine {
  width: 114px;
  height: 118px;
  margin-top: 84px;
}
.steps_one {
  display: flex;
  justify-content: space-around;
}
.steps_two {
  display: flex;
  justify-content: space-around;
}
.steps_three {
  display: flex;
  justify-content: space-around;
}
.steps_one_l {
  width: 204px;
  height: 85px;
  background: url(../../static/current_m.png) no-repeat;
  background-size: 204px 85px;
  line-height: 74px;
  color: #fff;
  text-align: center;
}
.steps_one_c {
  width: 204px;
  height: 74px;
  background: #f4f4f4;
  border-radius: 10px;
  line-height: 74px;
  color: #a1a1a1;
  text-align: center;
}
.steps_one_r {
  width: 204px;
  height: 74px;
  background: #f4f4f4;
  border-radius: 10px;
  line-height: 74px;
  color: #a1a1a1;
  text-align: center;
}
.bktitle {
  width: 100%;
  height: 105px;
  p {
    color: #666666;
    text-align: center;
    padding-top: 40px;
    font-size: 30px;
    letter-spacing: 2px;
  }
}
.bkDesc {
  width: calc(100% - 60px);
  padding: 10px 30px 30px 30px;
  p {
    font-family: PingFangSC-Regular;
    color: #ee2e2e;
    text-align: center;
    font-size: 28px;
    letter-spacing: 2px;
  }
}
.img1 {
  padding-top: 30px;
}
.usema {
  width: 200px;
}
.cia {
  width: 59%;
  // height: 350px;
  margin: 20px auto;
  p {
    margin: 20px 0 0 60px;
    color: rgb(139, 139, 139);
  }
}
.btnDiv{
  width: 100%;
  height: 150px;
  .btnStyle {
    display: block;
    width: 120px;
    height: 50px;
    // margin: 30px 60px;
    margin: 0 auto;
    border-radius: 10px;
    background: red;
    color: rgb(255, 255, 255);
  }
}
.tu {
  width: 220px;
  display: flex;
  position: relative;
}
.tu1 {
  // width: 170px;
  display: flex;
}
.li2 {
  width: 600px;
  padding-right: 30px;
}
header {
  width: 100%;
  height: 110px;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(241, 235, 235);
  ul {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: rgb(0, 0, 0);
    font-size: 40px;
    text-align: center;
    li {
      height: 120px;
      line-height: 120px;
      display: flex;
      align-items: center;
    }
  }
  .img_menu{
    width: 40px;
    height: 36px;
    margin-right: 30px;
  }
  .img_back{
    width: 70px;
    height: 70px;
    margin-left: 24px;
  }
}
/deep/.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
   border: none;
}
/deep/.van-cell::after{
  border: none;
}
.border{
  border-bottom: #ee2e2e solid 1px;
}
</style>
<style lang="scss">
.van-uploader__wrapper {
  position: relative;
  height: 150px;
}
.up_foot_box .van-uploader__wrapper{
  height: auto !important;
  }
.van-uploader__preview {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  background: #fff;
}
.van-uploader__upload {
  position: absolute;
  left: 0;
  top: 0;
}
.uploadBox{
  position: absolute;
  left: 220px;
  top: 0;
  width: 140px;
  height: 140px;
  background: transparent;
  z-index: 999;
  // border: 1px solid #ee2e2e;
}
.vue-image-crop-upload .vicp-wrap {
  width: 660px !important;
}
.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range][type=range] {
  display: none !important;
}
.up_foot_box{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px
   }
   .up_foot_button{
    background: #ee2e2e;
    color: #fff !important;
    outline: none;
    border: none;
    margin-right: 10px;
   }
</style>
<style>
.vicp-crop-left{
    float: none !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   }
   .van-toast {
    z-index: 9999999 !important;
   }

</style>
